import * as React from "react";
const B2 = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.417 26.5H17.917C24.167 26.5 26.667 24 26.667 17.75V10.25C26.667 4 24.167 1.5 17.917 1.5H10.417C4.16699 1.5 1.66699 4 1.66699 10.25V17.75C1.66699 24 4.16699 26.5 10.417 26.5Z"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66699 14.8751L9.16699 14.8501C10.1045 14.8501 11.1545 15.5626 11.5045 16.4376L12.9295 20.0376C13.2545 20.8501 13.767 20.8501 14.092 20.0376L16.9545 12.7751C17.2295 12.0751 17.742 12.0501 18.092 12.7126L19.392 15.1751C19.7795 15.9126 20.7795 16.5126 21.6045 16.5126H26.6795"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default B2;
